import {TamanhoTheme, Tema} from './Tema';

const color_primary = '#00629B';

export const TemaClaro: Tema = {
  nome: 'LightTheme',
  tamanho: TamanhoTheme,

  texto: {
    cor_primaria: 'rgba(0, 98, 155, 0.86)',

    enfase_alta: 'rgb(23, 43, 77)',
    enfase_media: 'rgba(23, 43, 77, .86)', // #42526E
    enfase_baixa: '#6c757d',
    desabilitado: 'rgba(0, 0, 0, .38)',

    erro: '#B00020',

    link: 'rgba(0, 0, 200, 0.86)'
  },

  image: {
    fillColor: 'rgba(0, 98, 155, 0.2)',
  },

  background: {
    cor_primaria: '#00629B',

    nivel_0: '#edf1f4',
    nivel_1: '#FFF',

    borda: '#ced4da',

    loading: '#dee0e5'
  },

  loading: color_primary,
};
